import React, { useState, useEffect, useRef } from "react";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import warningIcon from "../../assets/images/warning-icon.png";
import ERPSBaseButton from "../custom/inputs/ERPSBaseButton";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import { marketManagementAction } from "../../actions/marketingManagement.action";
import { useSelector, useDispatch } from "react-redux";
import ErrorMessage from "../custom/containers/ErrorMessage";
import parse from "html-react-parser";
import { validateURL } from "../../utils/helper";
import DialogHeader from "../custom/inputs/ERPSBaseModelDialog";
import store from "../../store";
import { ResponsiveBox, Card, CardContent, Dialog, DialogActions, DialogContent, Icon, Stack, Typography, HStack } from "../primitives";

function Dashboard(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getDashboardErrorMessage = useSelector(
    (state) => state.marketingManagementReducer?.getDashboardError
  );
  const getDashboardMessage = useSelector(
    (state) => state.marketingManagementReducer?.getDashboardMessage
  );
  const language = useSelector(
    (state) => state.loginUserReducer?.user?.languageCode
  );
  const [showExceptionMessage, setShowExceptionMessage] = useState(false);

  const uniqueEmailAddress = useSelector(
      (state) => state.loginUserReducer?.user?.uniqueEmailAddress
  );


  const billerId = useSelector((state) =>
     state.loginUserReducer?.user?.searchBillerFilesDto?.fi_biller_with_biller_id.split('-')[0]
  );


  const [openCancelDialog, setOpenCancelDialog] = useState(uniqueEmailAddress === "N");

  const popUpLoadedOnce = localStorage.getItem("popUpLoadedOnce");

  const handleRedirect = () => {
    localStorage.setItem("popUpLoadedOnce", true);
    props.history.push("/account-settings", {
      emailHighlight: true});
  };


  const [messagesList, setMessagesList] = useState([
    {
      E: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 1,
        type: t("erps.header.language.english_label"),
      },
      F: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 1,
        type: t("erps.header.language.french_label"),
      },
      messageId: 1,
    },
    {
      E: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 2,
        type: t("erps.header.language.english_label"),
      },
      F: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 2,
        type: t("erps.header.language.french_label"),
      },
      messageId: 2,
    },
    {
      E: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 3,
        type: t("erps.header.language.english_label"),
      },
      F: {
        header: "",
        message: "",
        urlText: "",
        urlLink: "",
        id: 3,
        type: t("erps.header.language.french_label"),
      },
      messageId: 3,
    },
  ]);
  useEffect(() => {
    dispatch(
      marketManagementAction.getDashboardMessage({ setShowExceptionMessage })
    );
  }, []);
  useEffect(() => {
    if (getDashboardMessage && getDashboardMessage.length) {
      let dataV1 = [];
      getDashboardMessage.forEach((data) => {
        dataV1.push({
          E: {
            header: data?.messageHeaderEnglish,
            message: data?.messageTextEnglish,
            urlText: data?.messageLinkTextEnglish,
            urlLink: data?.messageUrlEnglish,
            type: t("erps.header.language.english_label"),
            iconType: data?.iconType
          },
          F: {
            header: data?.messageHeaderFrench,
            message: data?.messageTextFrench,
            urlText: data?.messageLinkTextFrench,
            urlLink: data?.messageUrlFrench,
            type: t("erps.header.language.french_label"),
            iconType: data?.iconType
          },
          messageId: data?.id,
        });
      });
      setMessagesList(dataV1);
    }
  }, [getDashboardMessage]);

  const handleCloseCancelDialog = () => {
    localStorage.setItem("popUpLoadedOnce", true);
    setOpenCancelDialog(false);
  };


  const getDialogContent = () => {
    return (
          <ResponsiveBox>
            <Typography style = {{fontSize : '16px'}} gutterBottom aria-describedby="dialog-message">
              {t("erps.email.change.popup.body.contentV1")}
              <strong>
              {t("erps.email.change.popup.body.contentV2")}
                </strong>
            </Typography>
              <Typography style = {{fontSize : '16px'}} gutterBottom aria-describedby="dialog-message">
                {t("erps.email.change.popup.body.contentV3")}
                {`${billerId}`}
                {")."}
                <br />
                {t("erps.email.change.popup.body.contentV4")}
            </Typography>
            <Typography style = {{fontSize : '16px'}} gutterBottom aria-describedby="dialog-message">
              <strong>
              {t("erps.email.change.popup.body.contentV5")}
              </strong>
            </Typography>
          </ResponsiveBox>
    );
  };

  const dynamicRoutes = store.getState()?.marketingManagementReducer.dynamicRoutes;
  const applicableDynamicRoute = dynamicRoutes?.filter(checkIfDynamicRoute);

  function checkIfDynamicRoute(route) {
    return sessionStorage.getItem("ultimateRoute") == route;
  }

  if(sessionStorage.getItem("referrer") && localStorage.getItem("type") == "billpay" &&  applicableDynamicRoute?.length > 0){
    props.history.push("/" + applicableDynamicRoute);
    sessionStorage.removeItem("ultimateRoute");
  }

  const renderLink = (urlText, urlLink) => {
    if(urlLink.startsWith("SSO-")){
      urlLink = urlLink.replace("SSO-", "");
      return <a href="" onClick={() => props.history.push("/bpp-" + urlLink.substring(urlLink.lastIndexOf("/") + 1))}>{urlText}</a>
    }

    return <ERPSBaseLink
          label={urlText || urlLink}
          to={{
            pathname: !validateURL(urlLink)
              ? `https://${urlLink}`
              : urlLink,
          }}
          target={"_blank"}
          className="signIn__card__content__link"
        />
  }

  const getCardComponent = (lang) => {
    const messagesContent = messagesList.map((data) => data[lang]);
  
    const renderIconAndMessage = (header, message, urlText, urlLink, iconType, idx) => {
      if (iconType === "warn")
        return (
          <HStack spacing={2} mt={2} key={"B_"+idx}>
            <Icon className="manageUsers__error__icon" aria-hidden={false}>
              <img src={warningIcon} alt="Warning"/>
            </Icon>
            {messageContents(header, message, urlText, urlLink)}
          </HStack>
        );

      return (
        <ResponsiveBox mt={2} key={"B_"+idx}>
          {messageContents(header, message, urlText, urlLink)}
        </ResponsiveBox>
      );
    };

    const messageContents = (header, message, urlText, urlLink) => {return (
      <>
        {header && (
          <Typography
            variant="h3"
            className="messageCenter__card__content__heading"
          >
            {header}
          </Typography>
        )}
        <Typography
          variant="body1"
          className="signIn__card__content__header"
        >
          {message ? parse(message) : ""}
          {message && <br />}
          {renderLink(urlText, urlLink)}
        </Typography>
      </>
    )};

    return (
      <>
        <Card className="messageCenter__card__container">
          <CardContent>
            <Typography
              variant="h2"
              className="messageCenter__card__content__header"
            >
              {t("erps.login.message.card.title", "Messages")}
            </Typography>
            {messagesContent.map(
              ({ header, message, urlText, urlLink, iconType }, idx) => renderIconAndMessage(header, message, urlText, urlLink, iconType, idx)
            )}
          </CardContent>
        </Card>
      </>
    );
  };

  return (
    <main>
      <ResponsiveBox ml={3} mt={2}>
        {showExceptionMessage && getDashboardErrorMessage && (
          <ResponsiveBox className="manageUsers__errorMsg__container" role="alert" mt={2}>
            <ErrorMessage error={getDashboardErrorMessage} />
          </ResponsiveBox>
        )}
        <ResponsiveBox mt={4}>
          <Typography variant="h1">
            {t("erps.home.dashboard.heading.dashboard")}
          </Typography>
        </ResponsiveBox>
        <ResponsiveBox>
          {getDashboardMessage?.length
            ? getCardComponent(language)
            : ""}
        </ResponsiveBox>
        {!popUpLoadedOnce && (
        <Dialog
            open={openCancelDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ style: {
                maxWidth: '750px'
              }}}
           >
          <DialogHeader
              id="alert-dialog-title"
          >
            {t("erps.email.change.popup.header.title")}
          </DialogHeader>
          <DialogContent
              id="alert-dialog-description"
          >
            {getDialogContent()}
          </DialogContent>
          <DialogActions >
            <ERPSBaseButton
                variant="primary"
                label={t("erps.email.change.popup.yes")}
                onClick={handleRedirect}
            />
            <ERPSBaseButton
                variant="secondary"
                label={t("erps.email.change.popup.no")}
                onClick={handleCloseCancelDialog}
            />
          </DialogActions>
        </Dialog> )}
      </ResponsiveBox>
    </main>
  );
}

export default withSidebar(Dashboard);
